import Script from 'next/script';

function generateGtmScript(gtmId: string) {
  return `window.dataLayer = window.dataLayer || [];
function gtag(){dataLayer.push(arguments);}
gtag('consent', 'default', {
  ad_storage: 'denied',
  ad_user_data: 'denied',
  ad_personalization: 'denied',
  analytics_storage: 'denied',
  functionality_storage: 'denied',
  personalization_storage: 'denied',
  security_storage: 'granted',
  wait_for_update: 500,
});
dataLayer.push({'gtm.start': new Date().getTime(), event: 'gtm.js'});
var s = document.createElement('script');
s.async = true;
s.src = 'https://www.googletagmanager.com/gtm.js?id=${gtmId}';
document.head.appendChild(s);
`;
}

function GoogleTagManager() {
  const gtmId = process.env.NEXT_PUBLIC_GTM_ID;

  if (!gtmId) return null;

  // Consent Mode v2 defaults + GTM loader in one script so defaults always run first.
  // Consent updates are sent by Usercentrics (Google Consent Mode enabled in UC admin).
  return (
    <Script id='gtm' strategy='afterInteractive'>
      {generateGtmScript(gtmId)}
    </Script>
  );
}

export default GoogleTagManager;
